import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { TrendingUpIcon } from 'lucide-react';
export function CaseStudies() {
  const cases = [{
    business: 'TFP Landscaping',
    industry: 'Landscaping & Design',
    location: 'Texas',
    before: {
      responseTime: '4 hours',
      responseRate: '70%',
      estimatesBooked: '2-3/week'
    },
    after: {
      responseTime: '20 minutes',
      responseRate: '100%',
      estimatesBooked: '6/week on autopilot'
    },
    testimonial: 'The AI handles all our initial inquiries and books estimates automatically. We went from chasing leads to having a full calendar.',
    name: 'TFP Landscaping',
    title: 'Client'
  }];
  return <section className="py-20 px-6 bg-[var(--white-smoke)]" data-id="element-33">
      <div className="max-w-6xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-35">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-36">
            Real Results from Real Contractors
          </h2>
          <p className="text-xl text-[var(--graphite-gray)] max-w-2xl mx-auto" data-id="element-37">
            See how fast response times transformed this landscaping business.
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto" data-id="element-38">
          {cases.map((caseStudy, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} data-id="element-39">
              <Card padding="lg" className="h-full flex flex-col" data-id="element-40">
                <div className="mb-6" data-id="element-41">
                  <h3 className="text-3xl font-bold text-[var(--jet-black)] mb-1" data-id="element-42">
                    {caseStudy.business}
                  </h3>
                  <p className="text-sm text-[var(--graphite-gray)]" data-id="element-43">
                    {caseStudy.industry}
                  </p>
                  <p className="text-xs text-[var(--graphite-gray)]" data-id="element-44">
                    {caseStudy.location}
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-45">
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded" data-id="element-46">
                    <p className="text-xs font-semibold text-red-800 mb-2" data-id="element-47">
                      BEFORE
                    </p>
                    <p className="text-sm text-red-900 mb-1" data-id="element-48">
                      <strong data-id="element-49">Response Time:</strong>{' '}
                      {caseStudy.before.responseTime}
                    </p>
                    <p className="text-sm text-red-900 mb-1" data-id="element-50">
                      <strong data-id="element-51">Response Rate:</strong>{' '}
                      {caseStudy.before.responseRate}
                    </p>
                    <p className="text-sm text-red-900" data-id="element-52">
                      <strong data-id="element-53">Estimates Booked:</strong>{' '}
                      {caseStudy.before.estimatesBooked}
                    </p>
                  </div>

                  <div className="bg-green-50 border-l-4 border-[var(--viridia-green)] p-4 rounded" data-id="element-54">
                    <p className="text-xs font-semibold text-green-800 mb-2" data-id="element-55">
                      AFTER
                    </p>
                    <p className="text-sm text-green-900 mb-1" data-id="element-56">
                      <strong data-id="element-57">Response Time:</strong>{' '}
                      {caseStudy.after.responseTime}
                    </p>
                    <p className="text-sm text-green-900 mb-1" data-id="element-58">
                      <strong data-id="element-59">Response Rate:</strong>{' '}
                      {caseStudy.after.responseRate}
                    </p>
                    <p className="text-sm text-green-900" data-id="element-60">
                      <strong data-id="element-61">Estimates Booked:</strong>{' '}
                      {caseStudy.after.estimatesBooked}
                    </p>
                  </div>
                </div>

                <div className="border-t pt-6" data-id="element-62">
                  <p className="text-lg text-[var(--graphite-gray)] italic mb-4" data-id="element-63">
                    "{caseStudy.testimonial}"
                  </p>
                  <div className="flex items-center gap-2" data-id="element-64">
                    <TrendingUpIcon className="w-5 h-5 text-[var(--viridia-green)]" data-id="element-65" />
                    <div data-id="element-66">
                      <p className="text-base font-semibold text-[var(--jet-black)]" data-id="element-67">
                        {caseStudy.name}
                      </p>
                      <p className="text-sm text-[var(--graphite-gray)]" data-id="element-68">
                        {caseStudy.title}
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}